export default __webpack_public_path__ + "static/media/keller-card-sorting-thumb.1a89fbbb.svg";